import AppClientItem from '../app-client-item'

export default
{
    components:
    {
        AppClientItem
    },

    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            mouse: {
                x: 0,
                y: 0,
                smooth: {
                    x: 0,
                    y: 0
                }
            },

            isPosterActive: false,
            posterSrc: ''
        }
    },

    created()
    {
        this.eventHub.$on('window:tick', this.onTick)
    },

    mounted()
    {
        this.$emit('page:ready')
    },

    destroyed()
    {
        this.eventHub.$off('window:tick', this.onTick)
    },

    methods:
    {
        onMouseMove(event)
        {
            this.mouse.x = event.pageX
            this.mouse.y = event.pageY - this.$root.scrollTop
        },

        onTick()
        {
            this.mouse.smooth.x += (this.mouse.x - this.mouse.smooth.x) * 0.1
            this.mouse.smooth.y += (this.mouse.y - this.mouse.smooth.y) * 0.1
        },

        onProjectOver(src)
        {
            this.isPosterActive = true
            this.posterSrc = src
        },

        onProjectLeave()
        {
            this.isPosterActive = false
            this.posterSrc = ''
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-clients/script.js